import { Navigate, useLocation } from "react-router-dom";

const LegacySettingsRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  params.set("view", "Settings");

  return <Navigate to={`/?${params.toString()}`} replace />;
};

export default LegacySettingsRedirect;
